import { Box } from '@chakra-ui/react';
import { KText } from 'ui-library/components';
import { ContactSearchItem } from '../item/ContactSearchItem';

export const ContactList = ({ contactData, searchTerm }) => {
  return (
    <Box>
      <KText
        textTransform="uppercase"
        lineHeight="26px"
        letterSpacing="1px"
        px="16px"
        mb="md"
        size="sm-medium"
        color="secondary-900"
      >
        contacts results
      </KText>
      {contactData?.contact.map((contact, index) => {
        return (
          <ContactSearchItem
            searchTerm={searchTerm}
            key={contact.id}
            contact={contact}
            showBorderBottom={index !== contactData?.contact?.length - 1}
          />
        );
      })}
    </Box>
  );
};
